import { gsap, ScrollTrigger } from '../global/gsap';

const initAccordions = (sections) => {
    const mm = gsap.matchMedia();

    mm.add('(min-width: 900px)', () => {
        sections.forEach((section) => {
            const fadingTitles = section.querySelectorAll(
                '.js-fading-titles *',
            );
            const accordions = section.querySelectorAll('.js-accordion');

            gsap.set(fadingTitles, { autoAlpha: 0, yPercent: 50 });

            if (fadingTitles[0]) {
                gsap.set(fadingTitles[0], { autoAlpha: 1, yPercent: 0 });
            }

            accordions.forEach((accordion, index) => {
                const currentTitle = fadingTitles[index];
                if (!currentTitle) return;

                ScrollTrigger.create({
                    trigger: accordion,
                    start: 'top 40%',
                    end: 'bottom 40%',

                    onEnter: () => {
                        if (gsap.getProperty(currentTitle, 'autoAlpha') === 1)
                            return;

                        gsap.to(fadingTitles, {
                            autoAlpha: 0,
                            yPercent: -50,
                            duration: 0.3,
                            overwrite: true,
                        });

                        gsap.fromTo(
                            currentTitle,
                            { autoAlpha: 0, yPercent: 50 },
                            {
                                autoAlpha: 1,
                                yPercent: 0,
                                duration: 0.4,
                                delay: 0.2,
                                overwrite: true,
                                immediateRender: false,
                            },
                        );
                    },

                    onEnterBack: () => {
                        if (gsap.getProperty(currentTitle, 'autoAlpha') === 1)
                            return;

                        gsap.to(fadingTitles, {
                            autoAlpha: 0,
                            yPercent: 50,
                            duration: 0.3,
                            overwrite: true,
                        });

                        gsap.fromTo(
                            currentTitle,
                            { autoAlpha: 0, yPercent: -50 },
                            {
                                autoAlpha: 1,
                                yPercent: 0,
                                duration: 0.4,
                                delay: 0.2,
                                overwrite: true,
                                immediateRender: false,
                            },
                        );
                    },
                });
            });

            ScrollTrigger.create({
                trigger: section,
                start: 'top top',
                end: 'bottom top',
                onLeaveBack: () => {
                    gsap.to(fadingTitles, {
                        autoAlpha: 0,
                        yPercent: 50,
                        duration: 0.3,
                        overwrite: true,
                    });
                    gsap.to(fadingTitles[0], {
                        autoAlpha: 1,
                        yPercent: 0,
                        duration: 0.3,
                        overwrite: true,
                    });
                },
                onLeave: () => {
                    gsap.to(fadingTitles, {
                        autoAlpha: 0,
                        yPercent: -50,
                        duration: 0.3,
                        overwrite: true,
                    });
                },
            });
        });

        return () => ScrollTrigger.getAll().forEach((t) => t.kill());
    });
};

export default initAccordions;
